<template>
  <div class="word_4"  ref="previewDom">
    
    <div class="a4">
      <div class="th">
        <div class="box box-lable" style="width:120px;height:70px;line-height:70px">工种类别</div>
        <div class="box" style="width:250px;height:70px;text-align:start;padding-left:10px">
          {{alldata.info.type_of_work}}
        </div>
        <div class="box box-lable" style="width:160px;height:70px;line-height:70px">专业分类</div>
        <div class="box" style="width:191px;height:70px">{{alldata.info.type_of_major}}</div>
      </div>
	  
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">工法名称</div>
	    <div class="box" style="width:599px;height:60px">{{alldata.info.name}}</div>
	  </div>
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">编写单位</div>
	    <div class="box" style="width:599px;height:60px">{{alldata.info.unit}}</div>
	  </div>
	  <div class="th">
	  	<div class="box box-lable" style="width:120px;height:70px;line-height:70px">联系人及电话</div>
	  	<div class="box" style="width:250px;height:70px;text-align:start;padding-left:10px">
	  	  {{alldata.info.phone}}
	  	</div>
	  	<div class="box box-lable" style="width:160px;height:70px;line-height:70px">电话</div>
	  	<div class="box" style="width:191px;height:70px">{{alldata.info.tel}}</div>
	  </div>
	  <div class="th">
	    <div class="box box-lable" style="width:120px;height:60px;line-height:60px">主要完成人</div>
	    <div class="box" style="width:599px;height:60px"><block v-for="(author,index) in alldata.info.author_names">{{author.name}} <block v-if="index + 1 < alldata.info.author_names.length">、</block></block></div>
	  </div>
	  <div class="th-1" style="margin-top: 30px;">
	    <div class="box-1" style="width:719px;height:60px">
			<div class="col col-2">贵州省级工法申报汇总表（附件2）</div>
			<div class="col col-1">贵州省级工法申报表(附件1)</div>
			<div class="col col-1">工法文本</div>
			<div class="col col-1">企业工法证明材料</div>
			<div class="col col-3">工法关键技术鉴定的有关资料</div>
		</div>
	    <div class="box-1" style="width:719px;height:60px">
			<div class="col-txt col-txt-1">
				<div class="txt-lab">盖章PDF</div>
				<a v-if="alldata.info.filelist1[0]" class="txt-see" target="_blank" :href="alldata.info.filelist1[0].url">查看</a>
			</div>
			<div class="col-txt col-txt-1">
				<div class="txt-lab">盖章PDF</div>
				<a v-if="alldata.info.filelist2[0]" class="txt-see" target="_blank" :href="alldata.info.filelist2[0].url">查看</a>
			</div>
			<div class="col-txt col-txt-1">
				<a v-if="alldata.info.filelist3[0]" class="txt-see" target="_blank" :href="alldata.info.filelist3[0].url">查看</a>
			</div>
			<div class="col-txt col-txt-1">
				<a v-if="alldata.info.filelist4[0]" class="txt-see" target="_blank" :href="alldata.info.filelist4[0].url">查看</a>
			</div>
			<div class="col-txt col-txt-1">
				<a v-if="alldata.info.filelist5[0]" class="txt-see" target="_blank" :href="alldata.info.filelist5[0].url">查看</a>
			</div>
			<div class="col-txt col-txt-3">
				<a v-if="alldata.info.filelist6[0]" class="txt-see" target="_blank" :href="alldata.info.filelist6[0].url">查看</a>
			</div>
		</div>
	  </div>
	  
	  <div class="th-1" style="margin-top: 30px;">
	    <div class="box-1" style="width:719px;">
	  			<div class="col col-1">工程应用证明</div>
	  			<div class="col col-1">经济效益证明</div>
	  			<div class="col col-1">科技查新报告</div>
	  			<div class="col col-1">涉及他方专利的无争议声明书</div>
	  			<div class="col col-1">关键技术标准、专利证书、科技成果获奖证明等其他有关材料</div>
	  			<div class="col col-3">工法应用的有关照片</div>
	  		</div>
	    <div class="box-1" style="width:719px;height:60px">
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist7[0]" class="txt-see" target="_blank" :href="alldata.info.filelist7[0].url">查看</a>
	  			</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist8[0]" class="txt-see" target="_blank" :href="alldata.info.filelist8[0].url">查看</a>
	  			</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist9[0]" class="txt-see" target="_blank" :href="alldata.info.filelist9[0].url">查看</a>
	  			</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist10[0]" class="txt-see" target="_blank" :href="alldata.info.filelist10[0].url">查看</a>
	  			</div>
	  			<div class="col-txt col-txt-1">
					<a v-if="alldata.info.filelist11[0]" class="txt-see" target="_blank" :href="alldata.info.filelist11[0].url">查看</a>
	  			</div>
	  			<div class="col-txt col-txt-3">
					<el-button type="text" class="txt-see txt-img"   @click="dialogTableVisible = true">查看</el-button>
					<!-- <a v-if="alldata.info.filelist12[0]" class="txt-see" target="_blank" :href="alldata.info.filelist12">查看</a> -->
	  			<el-dialog  title="工法应用的有关照片" :visible.sync="dialogTableVisible" center="true">
					<div class="demo-image__lazy" >
					  <el-image v-for="item in alldata.info.filelist12" :key="item['url']" :src="item['url']" lazy></el-image>
					</div>
	  			</el-dialog>
				</div>
	  		</div>
	  </div>
	  
    </div>
  </div>
  
</template>


<script>
import self_adaption from './adaption'
export default {
  props: {
	dialogTableVisible:{
		type:Boolean,
		default:false,
	},
    alldata: {
      type: Object,
      default: {},
      year:""
    },
  },
  data() {
    return {
      xiahuaxian:
        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
    };
  },
  mounted() {
    self_adaption()
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
  },
  methods:{
    
  }
};
</script>

<style lang="less" scoped>
.a4 {
  padding: 50px 60px 50px 60px;
  width: 842px;
  // height: 1346px;
  min-height: 719px;
  height: 719px;
  margin: 0 auto;
  margin-top: 32px;
  background: #ffffff;
  box-sizing: border-box;
  color: black;
  box-shadow: 0px 12px 22px rgba(0, 0, 0, 0.16);
  margin-bottom: 100px;
  p,
  h1 {
    font-family: "仿宋";
  }
  .th {
    display: flex;
    align-items: center;
    font-family: "仿宋";
	justify-content: center;
  }
  .box {
    box-sizing: border-box;
    border: 1px solid #D4DBDD;
    margin: 0 -1px -1px 0;
    text-align: center;
    font-size: 14px;
	font-weight: bold;
	display: flex;
	justify-content: center;
	align-items: center;
  }
  .th-1{
    // display: flex;
    // align-items: center;
    font-family: "仿宋";
  }
  .box-lable{
	background-color: #F5F9FB;
	color: #194ABE;
	font-weight: 400;
  }
  .box-1 {
    box-sizing: border-box;
    border: 1px solid #D4DBDD;
    margin: 0 -1px -1px 0;
    font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #194ABE;
  }
  .col{
	width: 120px;
	margin: 8px;
	background-color: #F5F9FB;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
  }
  .col-1{
	width: 119px;
	border-right: 1px solid #D4DBDD;
  }
  .col-2{
	width: 238px;
	border-right: 1px solid #D4DBDD;
  }
  .col-3{
	width: 120px;
  }
  
  .col-txt{
	width: 119px;
	height: 58px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #333333;
  }
  .col-txt-1{
	width: 119px;
	border-right: 1px solid #D4DBDD;
  }
  .col-txt-2{
	width: 238px;
	border-right: 1px solid #D4DBDD;
  }
  .col-txt-3{
	width: 120px;
  }
  .txt-lab{
	  color: #7C828A;
	  margin-bottom: 2px;
  }
  .txt-see{
	  font-weight: bold;
	  color: #333333;
	  cursor: pointer;
	  text-decoration: underline;
  }
  .txt-img{
	  color: #194ABE;
  }
  .txt-see:link{
	  color: #194ABE;
  }
  .txt-see:visited{ 
	  color: #194ABE;
  }
  .txt-see:hover{
	  color: #194ABE;
  }
}
</style>
